import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import '../assets/style/RoleModals.css'; 
import { deleteRoleApi } from "../api/roleMasterApi";
import { toast } from "react-toastify";

const DeleteRoleConfirmModal = (props: any) => {
    const {toggle, openModal, role, setFlag} = props
    const dispatch: any = useDispatch();
    const [showActiveUsers, setShowActiveUsers] = useState([]);

    const handleCloseModal = () => {
        toggle();
        setFlag(false);
    };

    const closeBtn = (
        <img
            src={require('../assets/img/close_modal.svg').default}
            onClick={handleCloseModal}
            className="close-icon"
            alt="Close"
        />
    );

    const handleDeleteRole = () => {
        dispatch(deleteRoleApi(role?.name, role?.id));
        setFlag(true);
    };

    const { storeDeleteRoleRes } = useSelector((state: any) => state.roleMaster);
    
    useEffect(() => {
        if(Object.keys(storeDeleteRoleRes)?.length > 0){
            if (storeDeleteRoleRes?.['RESPONSE'] === 'deleted') {
                toggle();
                setFlag(true);
            }
            else {
                if(storeDeleteRoleRes?.data === 'USERS ACTIVE') {
                    setShowActiveUsers(storeDeleteRoleRes?.response);
                }
                else{                    
                    toast.error('Unable to delete the role.')
                }
            }
        }
    }, [storeDeleteRoleRes]);

    return (
        <Modal isOpen={openModal} toggle={toggle} centered backdrop="static">
            <ModalHeader toggle={toggle} close={closeBtn}>
                Delete Role
            </ModalHeader>
            <ModalBody>
                {showActiveUsers?.length > 0 ? 
                    <>
                        <p className="warning-message">
                            Warning !!
                        </p>
                        <p>
                            Unable to delete role. Active user(s) present:
                        </p>
                        <p><b>{showActiveUsers?.join(', ')}</b></p>
                    </>
                    :
                    <span className="modal-text">
                        Are you sure you want to delete the Role <b>{role?.name}</b>?
                    </span>
                }
            </ModalBody>
            {!(showActiveUsers?.length > 0) &&
            <ModalFooter>
                <Button className="button extra-width" onClick={handleDeleteRole}>
                    Yes
                </Button>
                <Button className="resetButton extra-width" onClick={handleCloseModal}>
                    No
                </Button>
            </ModalFooter>}
        </Modal>
    );
};

export default DeleteRoleConfirmModal;